import GlueFrame from "./../_lib/GlueFrame/GlueFrame";

window.youTube = function(id, videoUrl) {
    if (window.__youtube_inited === undefined) {
        window.__youtube_inited = true;

        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";

        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.pendingPlayers = [];
        window.onYouTubeIframeAPIReady = function() {
            window.pendingPlayers.forEach(function(player) {
                player.ytPlayer = new YT.Player(player.container, {
                    height: "720",
                    width: "1280",
                    videoId: player.videoId,
                    events: {
                        onReady: player.onPlayerReady,
                        onStateChange: player.onPlayerStateChange
                    },
                    playerVars: {
                        controls: 0,
                        modestbranding: 1,
                        showinfo: 0,
                        rel: 0
                    }
                });
            });
        };
    }

    var thumbnail = document
        .getElementById(`video-container-${id}`)
        .querySelector(".module-video-thumbnail");
    var timeout = setTimeout(function() {});
    var player = {
        container: document.getElementById(`video-${id}`),
        videoId: `${videoUrl}`,
        onPlayerReady: function(event) {
            // event.target.playVideo()
        },
        onPlayerStateChange: function(event) {
            if (event.data === 0) {
                player.ytPlayer.stopVideo();
                thumbnail.style.zIndex = 0;
                thumbnail.style.opacity = 1;
            }
            if (event.data === 1) {
                clearTimeout(timeout);
                thumbnail.style.opacity = 0;
                timeout = timeout = setTimeout(function() {
                    thumbnail.style.zIndex = -1;
                }, 500);
            }
            if (event.data === 2) {
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    thumbnail.style.zIndex = 0;
                    thumbnail.style.opacity = 1;
                }, 200);
            }
        }
    };

    thumbnail.addEventListener("click", function(event) {
        if (player.ytPlayer) {
            if (player.ytPlayer.getPlayerState() !== 1) {
                if (event.target.classList.contains("video-trigger")) {
                    player.ytPlayer.playVideo();
                    thumbnail
                        .querySelector(".module-video-play-button")
                        .classList.add("starting");
                    setTimeout(function() {
                        thumbnail
                            .querySelector(".module-video-play-button")
                            .classList.remove("starting");
                    }, 1000);
                }
            }
        }
    });

    window.pendingPlayers.push(player);
};

window.vimeo = function(id, videoUrl) {
    var options = {
        id: `${videoUrl}`,
        height: 720,
        width: 1280,
        loop: false
    };
    var thumbnail = document
        .getElementById(`video-container-${id}`)
        .querySelector(".module-video-thumbnail");
    var timeout = setTimeout(function() {});
    var player = new Vimeo.Player(`video-${id}`, options);

    player.on("play", function() {
        clearTimeout(timeout);
        thumbnail.style.opacity = 0;
        timeout = timeout = setTimeout(function() {
            thumbnail.style.zIndex = -1;
        }, 500);
    });
    player.on("pause", function() {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            thumbnail.style.zIndex = 0;
            thumbnail.style.opacity = 1;
        }, 200);
    });
    player.on("ended", function() {
        thumbnail.style.zIndex = 0;
        thumbnail.style.opacity = 1;
    });

    thumbnail.addEventListener("click", function(event) {
        if (event.target.classList.contains("video-trigger")) {
            player.play();
            thumbnail
                .querySelector(".module-video-play-button")
                .classList.add("starting");
            setTimeout(function() {
                thumbnail
                    .querySelector(".module-video-play-button")
                    .classList.remove("starting");
            }, 1000);
        }
    });
};

window.twentyThree = function(id, videoUrl) {
    var Player;
    var embedIframe = `<iframe src="${videoUrl}&source=embed&color=ff0000&autoPlay=0&portrait=0&autoMute=0" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    var container = document.getElementById(`video-${id}`);
    container.innerHTML = embedIframe;
    var frame = container.querySelectorAll("iframe")[0];
    var thumbnail = document
        .getElementById(`video-container-${id}`)
        .querySelector(".module-video-thumbnail");
    var timeout = setTimeout(function() {});

    var lookForGlueGrame = function(callback) {
        if (typeof GlueFrame != "undefined") {
            callback();
        } else {
            window.setTimeout(function() {
                lookForGlueGrame(callback);
            }, 100);
        }
    };

    var loadGlueFrame = function(frame, callback) {
        if (typeof GlueFrame != "undefined") {
            callback(frame);
        } else {
            lookForGlueGrame(function() {
                callback(frame);
            });
        }
    };

    loadGlueFrame(frame, function() {
        Player = new GlueFrame(frame, `Player${id}`);

        Player.bind("player:video:play", function(e) {
            clearTimeout(timeout);
            thumbnail.style.opacity = 0;
            timeout = timeout = setTimeout(function() {
                thumbnail.style.zIndex = -1;
            }, 500);
        });
        Player.bind("player:video:pause", function(e) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                thumbnail.style.zIndex = 0;
                thumbnail.style.opacity = 1;
            }, 200);
        });
        Player.bind("player:video:end", function(e) {
            thumbnail.style.zIndex = 0;
            thumbnail.style.opacity = 1;
        });
    });

    thumbnail.addEventListener("click", function(event) {
        if (event.target.classList.contains("video-trigger")) {
            Player.set("playing", true);
            thumbnail
                .querySelector(".module-video-play-button")
                .classList.add("starting");
            setTimeout(function() {
                thumbnail
                    .querySelector(".module-video-play-button")
                    .classList.remove("starting");
            }, 1000);
        }
    });
};
